import { HORIZON, POLYGON, SEISMIC_SURVEY } from '@core/core/constants'
import type {
  BaseObjectProperties,
  Calculation,
  FormDataML,
  SeismophationsCalculation,
  SeismophationsParams,
} from '@core/core/types'
import type { FC } from 'react'

import { SelectGroup } from '../../SelectGroup'

type SeismophationsObjectProps = {
  formData: FormDataML
  calculation: Calculation
  updateCalculation: (calc: Calculation) => void
}

export const SeismophationsObjects: FC<SeismophationsObjectProps> = ({
  formData,
  calculation,
  updateCalculation,
}) => {
  const showPolygonSelector = (formData.algorithm as SeismophationsParams).additionalTraining
  const params = calculation.params as SeismophationsCalculation

  const update = (field: keyof SeismophationsCalculation) => (value: BaseObjectProperties) => {
    updateCalculation({ ...calculation, params: { ...params, [field]: value } })
  }

  return (
    <>
      <SelectGroup
        type={SEISMIC_SURVEY}
        withParams={true}
        value={params.seismicSurvey}
        onChange={update('seismicSurvey')}
      />
      <SelectGroup
        type={HORIZON}
        withParams={true}
        value={params.horizon}
        onChange={update('horizon')}
      />
      {!!showPolygonSelector && (
        <SelectGroup
          type={POLYGON}
          tooltip="Границы сейсмофаций должны быть замкнуты"
          value={{ ...params.polygon, parameter: null }}
          onChange={update('polygon')}
        />
      )}
    </>
  )
}
